import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route';
import Loadable from 'react-loadable';
import { createBrowserHistory } from 'history';
import CoreLayout from '../page/global';
import { Loading } from '@HOC';
import title from '@Title';
import { bundleComponent } from './Bundles';
import routerConfigData from './router.config.js';

export const history = createBrowserHistory();

const login = Loadable({
  loader: () => import('../page/login'),
  loading: Loading,
  render: bundleComponent(title.login),
});
const userRegistered = Loadable({
  loader: () => import('../page/userRegistered'),
  loading: Loading,
  render: bundleComponent(title.userRegistered),
});
// 注册
const supplierRegistered = Loadable({
  loader: () => import('../page/supplierRegistered'),
  loading: Loading,
  render: bundleComponent(title.userRegistered),
});
// 我的资料
const myProfile = Loadable({
  loader: () => import('../page/supplierRegistered'),
  loading: Loading,
  render: bundleComponent(title.myProfile),
});
// 意向供应商账注册
const intendedSupplierRegistered = Loadable({
  loader: () => import('../page/intendedSupplierRegistered'),
  loading: Loading,
  render: bundleComponent(title.intendedSupplierRegistered),
});
// 意向供应商账资料
const intendedSupplier = Loadable({
  loader: () => import('../page/intendedSupplierRegistered'),
  loading: Loading,
  render: bundleComponent(title.intendedSupplier),
});
const home = Loadable({
  loader: () => import('../page/home'),
  loading: Loading,
  render: bundleComponent(title.home),
});
const notFound404 = Loadable({
  loader: () => import('../page/notFound404'),
  loading: Loading,
  render: bundleComponent(title.notFound404),
});
const yhlist = Loadable({
  loader: () => import('../page/yhLifeFreightStatement'),
  loading: Loading,
  render: bundleComponent('永辉生活运费对账单'),
});
//订退货管理

//订货通知单
const orderNotice = Loadable({
  loader: () => import('../page/orderNotice'),
  loading: Loading,
  render: bundleComponent(title.orderNotice),
});

//预采通知单
const PrePurchase = Loadable({
  loader: () => import('../page/prePurchase'),
  loading: Loading,
  render: bundleComponent(title.prePurchase),
});
//预采需求看板
const PreProcurement = Loadable({
  loader: () => import('../page/preProcurement'),
  loading: Loading,
  render: bundleComponent(title.preProcurement),
});
//预采通知单详情
const PrePurchaseDetail = Loadable({
  loader: () => import('../page/prePurchase/components/detailModal'),
  loading: Loading,
  render: bundleComponent(title.prePurchaseDetail),
});
//订货通知单详情
const OrderNoticeDes = Loadable({
  loader: () => import('../page/orderNoticeDes'),
  loading: Loading,
  render: bundleComponent(title.orderNoticeDes),
});

//退货冲销单详情
const ReturnDebitNoteDetail = Loadable({
  loader: () => import('../page/returnDebitNoteDetail'),
  loading: Loading,
  render: bundleComponent(title.ReturnDebitNoteDetail),
});
//订货通知单打印门店明细
const StoreDetails = Loadable({
  loader: () => import('../page/storeDetails'),
  loading: Loading,
  render: bundleComponent(title.StoreDetails),
});
//订货通知单打印单据
const printDocument = Loadable({
  loader: () => import('../page/printDocument'),
  loading: Loading,
  render: bundleComponent(title.printDocument),
});

//验收单
const orderAccept = Loadable({
  loader: () => import('../page/orderAccept'),
  loading: Loading,
  render: bundleComponent(title.orderAccept),
});
//验收单详情
const orderAcceptDes = Loadable({
  loader: () => import('../page/orderAcceptDes'),
  loading: Loading,
  render: bundleComponent(title.orderAcceptDes),
});
// 验收单打印
const orderAcceptPrint = Loadable({
  loader: () => import('../page/orderAcceptPrint'),
  loading: Loading,
  render: bundleComponent(title.orderAcceptPrint),
});

//退货通知单
const returnNotice = Loadable({
  loader: () => import('../page/returnNotice'),
  loading: Loading,
  render: bundleComponent(title.returnNotice),
});
//退货通知单详情
const returnNoticeDes = Loadable({
  loader: () => import('../page/returnNoticeDes'),
  loading: Loading,
  render: bundleComponent(title.returnNoticeDes),
});
//退货通知单打印
const returnNoticePrint = Loadable({
  loader: () => import('../page/returnNoticePrint'),
  loading: Loading,
  render: bundleComponent(title.returnNoticePrint),
});

//退货单
const returnFrom = Loadable({
  loader: () => import('../page/returnFrom'),
  loading: Loading,
  render: bundleComponent(title.returnFrom),
});

// 委外委外实时分拣数量查询
const SortingDataQuery = Loadable({
  loader: () => import('../page/sortingDataQuery'),
  loading: Loading,
  render: bundleComponent(title.SortingDataQuery),
});
//退货单详情
const returnFromDes = Loadable({
  loader: () => import('../page/returnFromDes'),
  loading: Loading,
  render: bundleComponent(title.returnFromDes),
});
//退货单打印
const returnFromPrint = Loadable({
  loader: () => import('../page/returnFromPrint'),
  loading: Loading,
  render: bundleComponent(title.returnFromPrint),
});
// 销售数据查询
const salesDataQuery = Loadable({
  loader: () => import('../page/salesDataQuery'),
  loading: Loading,
  render: bundleComponent(title.salesDataQuery),
});

// 退货冲销单
const ReturnDebitNote = Loadable({
  loader: () => import('../page/returnDebitNote'),
  loading: Loading,
  render: bundleComponent(title.returnDebitNote),
});

//系统设置
//修改登录密码
const editPwd = Loadable({
  loader: () => import('../page/editPwd'),
  loading: Loading,
  render: bundleComponent(title.editPwd),
});
//修改登录密码
const accountPhoneEdit = Loadable({
  loader: () => import('../page/accountPhoneEdit'),
  loading: Loading,
  render: bundleComponent(title.accountPhoneEdit),
});
//设置默认供应商
const defaultSelect = Loadable({
  loader: () => import('../page/defaultSelect'),
  loading: Loading,
  render: bundleComponent(title.defaultSelect),
});

// 找回手机号
const FindPhoneNum = Loadable({
  loader: () => import('../page/findPhoneNum'),
  loading: Loading,
  render: bundleComponent(title.FindPhoneNum),
});
//供应商与微信管理
const supplierAndWeiChat = Loadable({
  loader: () => import('../page/supplierAndWeiChat'),
  loading: Loading,
  render: bundleComponent(title.supplierAndWeiChat),
});

//供应商对账
const reconciliationManagement = Loadable({
  loader: () => import('../page/reconciliationManagement'),
  loading: Loading,
  render: bundleComponent(title.reconciliationManagement),
});
const reconciliationBillList = Loadable({
  //供应商对账-单据明细列表
  loader: () => import('../page/reconciliationDetail/billList'),
  loading: Loading,
  render: bundleComponent(title.reconciliationManagement),
});

// 电子签章业务
const businessQueries = Loadable({
  loader: () => import('../page/businessQueries'),
  loading: Loading,
  render: bundleComponent(title.businessQueries),
});
const changeQueries = Loadable({
  loader: () => import('../page/changeQueries'),
  loading: Loading,
  render: bundleComponent(title.changeQueries),
});
const changeQueriesDeta = Loadable({
  loader: () => import('../page/changeQueries/components/FullModal'),
  loading: Loading,
  render: bundleComponent(title.changeQueries),
});
const applyApproval = Loadable({
  loader: () => import('../page/applyApproval'),
  loading: Loading,
  render: bundleComponent(title.applyApproval),
});
const applyApprovalDetails = Loadable({
  loader: () => import('../page/applyApproval/components/FullModal'),
  loading: Loading,
  render: bundleComponent(title.applyApproval),
});
const phoneChangeApproval = Loadable({
  loader: () => import('../page/phoneChangeApproval'),
  loading: Loading,
  render: bundleComponent(title.phoneChangeApproval),
});
const businessApplications = Loadable({
  loader: () => import('../page/businessApplications'),
  loading: Loading,
  render: bundleComponent(title.businessApplications),
});
const editPhone = Loadable({
  loader: () => import('../page/editPhone'),
  loading: Loading,
  render: bundleComponent(title.editPhone),
});
const PurchaseOrderMonitoring = Loadable({
  loader: () => import('../page/PurchaseOrderMonitoring'),
  loading: Loading,
  render: bundleComponent(title.PurchaseOrderMonitoring),
});
// 供应商费用申诉
const SupplierFeeComplaint = Loadable({
  loader: () => import('../page/SupplierFeeComplaint'),
  loading: Loading,
  render: bundleComponent(title.SupplierFeeComplaint),
});
//供应商对账各个详情页面-打印
const reconciliationAndPayment = Loadable({
  loader: () => import('../page/reconciliationDetail/components/reconciliationAndPayment'),
  loading: Loading,
  render: bundleComponent('打印'),
});
const entryAndCore = Loadable({
  //发票录入和票核对
  loader: () => import('../page/entryAndCore'),
  loading: Loading,
  render: bundleComponent(title.entryAndCore),
});
const entryAndCoreDetaNew = Loadable({
  //发票录入和票核对详情
  loader: () => import('../page/entryAndCore/components/FullModal'),
  loading: Loading,
  render: bundleComponent(title.entryAndCore),
});
const entryAndCoreDeta = Loadable({
  //发票录入和票核对详情
  loader: () => import('../page/entryAndCore/components/FullModalOld'),
  loading: Loading,
  render: bundleComponent(title.entryAndCore),
});
const reconciliationBillCostDetail = Loadable({
  //供应商对账-费用单明细详情
  loader: () => import('../page/reconciliationDetail/billCostDetail'),
  loading: Loading,
  render: bundleComponent(title.reconciliationManagement),
});
const reconciliationBillDetail = Loadable({
  //供应商对账-单据详情
  loader: () => import('../page/reconciliationDetail/billDetail'),
  loading: Loading,
  render: bundleComponent(title.reconciliationManagement),
});

const reconciliationClaimDetail = Loadable({
  //供应商对账-认领详情
  loader: () => import('../page/reconciliationDetail/claimDetails'),
  loading: Loading,
  render: bundleComponent('认领详情'),
});

// 表报查询
const signatureStatement = Loadable({
  loader: () => import('../page/signatureStatement'),
  loading: Loading,
  render: bundleComponent(title.signatureStatement),
}); //已签章的对账单
const unpaidAmount = Loadable({
  //报表查询-供应商款项信息查询
  loader: () => import('../page/unpaidAmount'),
  loading: Loading,
  render: bundleComponent(title.unpaidAmount),
});
const documentFreezing = Loadable({
  //报表查询-对账单据明细查询
  loader: () => import('../page/documentFreezing'),
  loading: Loading,
  render: bundleComponent(title.documentFreezing),
});
const vendorPayment = Loadable({
  //报表查询-付款单查询
  loader: () => import('../page/vendorPayment'),
  loading: Loading,
  render: bundleComponent(title.vendorPayment),
});
const reconciliationInformation = Loadable({
  //报表查询-对账信息查询
  loader: () => import('../page/reconciliationInformation'),
  loading: Loading,
  render: bundleComponent(title.reconciliationInformation),
});
const invoiceManagement = Loadable({
  //报表查询-票核情况查询
  loader: () => import('../page/invoiceManagement'),
  loading: Loading,
  render: bundleComponent(title.invoiceManagement),
});
const expenseQuery = Loadable({
  //报表查询-供应商费用单查询
  loader: () => import('../page/expenseQuery'),
  loading: Loading,
  render: bundleComponent(title.expenseQuery),
});

//商品管理-商品库存报价管理
const productStockPrice = Loadable({
  loader: () => import('../page/productStockPrice'),
  loading: Loading,
  render: bundleComponent(title.productStockPrice),
});

//商品管理-商品库存报价管理导入
const productStockPriceImport = Loadable({
  loader: () => import('../page/productStockPriceImport'),
  loading: Loading,
  render: bundleComponent(title.productStockPriceImport),
});

const reserveDeliver = Loadable({
  loader: () => import('../page/reserveDeliver'),
  loading: Loading,
  render: bundleComponent(title.reserveDeliver),
});

const reservationDetail = Loadable({
  loader: () => import('../page/reserveDeliver/components/details'),
  loading: Loading,
  render: bundleComponent(title.reserveDeliverDetail),
});

//bbc履约管理
const Scope = Loadable({
  loader: () => import('../page/bbcPerformanceManagement/Scope'),
  loading: Loading,
  render: bundleComponent(title.Scope),
});

const holiday = Loadable({
  loader: () => import('../page/bbcPerformanceManagement/holiday'),
  loading: Loading,
  render: bundleComponent(title.holiday),
});

const expressSearch = Loadable({
  loader: () => import('../page/bbcPerformanceManagement/expressSearch'),
  loading: Loading,
  render: bundleComponent(title.expressSearch),
});

const bbcOrderManagement = Loadable({
  loader: () => import('../page/bbcOrderManageMent'),
  loading: Loading,
  render: bundleComponent(title.bbcOrderManagement),
});

const bbcGoodsManagement = Loadable({
  loader: () => import('../page/bbcGoodsManagement'),
  loading: Loading,
  render: bundleComponent(title.bbcGoodsManagement),
});

const bbcOrderDetail = Loadable({
  loader: () => import('../page/bbcOrderDetail'),
  loading: Loading,
  render: bundleComponent(title.bbcOrderDetail),
});

const bbcGoodsView = Loadable({
  loader: () => import('../page/bbcGoodsView'),
  loading: Loading,
  render: bundleComponent(title.bbcGoodsView),
});

const NewbbcGoodsView = Loadable({
  loader: () => import('../page/NewbbcGoodsView'),
  loading: Loading,
  render: bundleComponent(title.NewbbcGoodsView),
});

const bbcGoodsChange = Loadable({
  loader: () => import('../page/bbcGoodsChange'),
  loading: Loading,
  render: bundleComponent(title.bbcGoodsChange),
});

const BbcGoodsChangeNew = Loadable({
  loader: () => import('../page/bbcGoodsChangeNew'),
  loading: Loading,
  render: bundleComponent(title.bbcGoodsChangeNew),
});

// 报价单
const priceList = Loadable({
  //发票录入和票核对
  loader: () => import('../page/priceManagement/priceList'),
  loading: Loading,
  render: bundleComponent(title.priceList),
});

// 商品型检证件
const supplyType = Loadable({
  loader: () => import('../page/cardManagement/supplyType'),
  loading: Loading,
  render: bundleComponent(title.supplyType),
});

// 商品型检证件 - 新
const credentialsTypeReportNew = Loadable({
  loader: () => import('../page/credentialsTypeReportNew'),
  loading: Loading,
  render: bundleComponent(title.supplyType),
});

// 商品型检证件
const BatchInspectionCertificate = Loadable({
  loader: () => import('../page/batchInspectionCertificate'),
  loading: Loading,
  render: bundleComponent(title.batchInspectionCertificate),
});
// 供应商证件
const credentialsSupplierReport = Loadable({
  loader: () => import('../page/credentialsSupplierReport'),
  loading: Loading,
  render: bundleComponent(title.supplierCredential),
});

// 供应商运费参数配置
const SupplierFreightRules = Loadable({
  loader: () => import('../page/askPriceManagement/supplierFreightRules'),
  loading: Loading,
  render: bundleComponent(title.supplierFreightRules),
});
// 中标候选商品池
const WinningBidder = Loadable({
  loader: () => import('../page/askPriceManagement/winningBidder'),
  loading: Loading,
  render: bundleComponent(title.winningBidder),
});

// 日最大供货能力配置
const MaximumDailySupplyCapacity = Loadable({
  loader: () => import('../page/askPriceManagement/maximumDailySupplyCapacity'),
  loading: Loading,
  render: bundleComponent(title.maximumDailySupplyCapacity),
});

// 报品报价管理
const BidManagement = Loadable({
  loader: () => import('../page/askPriceManagement/bidManagement'),
  loading: Loading,
  render: bundleComponent(title.bidManagement),
});

// 询价管理
const InquiryPrice = Loadable({
  loader: () => import('../page/askPriceManagement/InquiryPrice'),
  loading: Loading,
  render: bundleComponent(title.inquiryPrice),
});

// 委外需求明细报表
const OutsourcingDetailsReport = Loadable({
  loader: () => import('../page/outsourcingDetailsReport'),
  loading: Loading,
  render: bundleComponent(title.outsourcingDetailsReport),
});
// 开票申请
const ApplyBilling = Loadable({
  loader: () => import('../page/ApplyBilling'),
  loading: Loading,
  render: bundleComponent(title.ApplyBilling),
});
// 开票申请记录
const InvoiceRecord = Loadable({
  loader: () => import('../page/InvoiceRecord'),
  loading: Loading,
  render: bundleComponent(title.InvoiceRecord),
});

// 开票查询
const BillingInquiry = Loadable({
  loader: () => import('../page/BillingInquiry'),
  loading: Loading,
  render: bundleComponent(title.BillingInquiry),
});

// 新品申请
const ProductCreate = Loadable({
  loader: () => import('../page/productCreate'),
  loading: Loading,
  render: bundleComponent(title.ProductCreate),
});

// 效期维护
const ValidityMaintenance = Loadable({
  loader: () => import('../page/validityMaintenance'),
  loading: Loading,
  render: bundleComponent(title.validityMaintenance),
});

// 代售业务对账
const reconciliationCommission = Loadable({
  loader: () => import('../page/reconciliationCommission'),
  loading: Loading,
  render: bundleComponent(title.reconciliationCommission),
});

// 委外需求看板
const QutsourcingRequirementDashboard = Loadable({
  loader: () => import('../page/qutsourcingRequirementDashboard'),
  loading: Loading,
  render: bundleComponent(title.qutsourcingRequirementDashboard),
});
// 委外需求看板
const InvoiceSend = Loadable({
  loader: () => import('../page/InvoiceSend'),
  loading: Loading,
  render: bundleComponent(title.InvoiceSend),
});

// 违约处置单
const DefaultDisposal = Loadable({
  loader: () => import('../page/defaultDisposal'),
  loading: Loading,
  render: bundleComponent(title.defaultDisposal),
});

// BBC联营商品管理
const BbcGoodsManagementNew = Loadable({
  loader: () => import('../page/bbcGoodsManagementNew'),
  loading: Loading,
  render: bundleComponent(title.bbcGoodsManagementNew),
});
// 发货时效
const DeliveryTime = Loadable({
  loader: () => import('../page/deliveryTime'),
  loading: Loading,
  render: bundleComponent(title.deliveryTime),
});

// 联营供应商安全库存配置
const SupplierSafetyStockConfig = Loadable({
  loader: () => import('../page/supplierSafetyConfig'),
  loading: Loading,
  render: bundleComponent(title.supplierSafetyStockConfig),
});
// 退货地址管理
const bbcReturnAddress = Loadable({
  loader: () => import('../page/bbcReturnAddress'),
  loading: Loading,
  render: bundleComponent(title.bbcReturnAddress),
});
/*  TODO:
 * 路由 以//开头
 */

const pageRouterList = routerConfigData.filter(item => !item.isDetail);

const mainLayout = () => (
  <CoreLayout location={history.location}>
    <Router history={history}>
      <CacheSwitch>
        {/*---------- 首页 ----------*/}
        <Route exact path="/home/index" cacheKey="/home/index" component={home} />
        <CacheRoute
          exact
          path="/bbc/bbcReturnAddress"
          cacheKey="/bbc/bbcReturnAddress"
          component={bbcReturnAddress}
          title="退货地址管理"
        />
        <CacheRoute
          exact
          path="/bbc/supplierSafetyConfig"
          cacheKey="/bbc/supplierSafetyConfig"
          component={SupplierSafetyStockConfig}
          title="联营供应商安全库存配置"
        />
        <CacheRoute
          exact
          path="/bbc/bbcGoodsManagementNew"
          cacheKey="/bbc/bbcGoodsManagementNew"
          component={BbcGoodsManagementNew}
          title="BBC联营商品管理"
        />
        <CacheRoute
          exact
          path="/home/intendedSupplier"
          cacheKey="/home/intendedSupplier"
          component={intendedSupplier}
          title="意向供应商账资料"
        />
        <CacheRoute
          exact
          path="/home/intendedSupplierRegistered"
          cacheKey="/home/intendedSupplierRegistered"
          component={intendedSupplierRegistered}
          title="意向供应商账注册"
        />
        <CacheRoute
          exact
          path="/bbc/bbcGoodsManagementNew"
          cacheKey="/bbc/bbcGoodsManagementNew"
          component={BbcGoodsManagementNew}
          title="BBC联营商品管理"
        />
        <CacheRoute
          exact
          path="/bbc/deliveryTime"
          cacheKey="/bbc/deliveryTime"
          component={DeliveryTime}
          title="发货时效"
        />
        <CacheRoute
          exact
          path="/supplierControl/defaultDisposal"
          cacheKey="/supplierControl/defaultDisposal"
          component={DefaultDisposal}
          title="违约处置单"
        />
        <CacheRoute
          exact
          path="/reportQuery/qutsourcingRequirementDashboard"
          cacheKey="/reportQuery/qutsourcingRequirementDashboard"
          component={QutsourcingRequirementDashboard}
          title="委外需求看板"
        />
        <CacheRoute
          exact
          path="/settlement/InvoiceSend"
          cacheKey="/settlement/InvoiceSend"
          component={InvoiceSend}
          title="票据寄送"
        />
        <CacheRoute
          exact
          path="/order/validityMaintenance"
          cacheKey="/order/validityMaintenance"
          component={ValidityMaintenance}
          title="效期维护"
        />
        <CacheRoute
          exact
          path="/commission/checking"
          cacheKey="/commission/checking"
          component={reconciliationCommission}
          title="代售业务对账"
        />
        <Route
          exact
          path="/productManagement/create"
          cacheKey="/productManagement/create"
          component={ProductCreate}
          title="新品申请"
        />
        {/* 我的资料 */}
        <Route
          exact
          path="/home/profile"
          cacheKey="/home/profile"
          component={myProfile}
          title="我的资料"
        />
        <Route
          exact
          path="/askPriceManagement/inquiryPrice"
          cacheKey="/askPriceManagement/inquiryPrice"
          component={InquiryPrice}
          title="询价管理"
        />
        <Route
          exact
          path="/askPriceManagement/supplierFreightRules"
          cacheKey="/askPriceManagement/supplierFreightRules"
          component={SupplierFreightRules}
          title="运费参数配置"
        />
        <Route
          exact
          path="/askPriceManagement/winningBidder"
          cacheKey="/askPriceManagement/winningBidder"
          component={WinningBidder}
          title="中标候选商品池"
        />
        <Route
          exact
          path="/askPriceManagement/maximumDailySupplyCapacity"
          cacheKey="/askPriceManagement/maximumDailySupplyCapacity"
          component={MaximumDailySupplyCapacity}
          title="日最大供货能力配置"
        />
        <Route
          exact
          path="/askPriceManagement/bidManagement"
          cacheKey="/askPriceManagement/bidManagement"
          component={BidManagement}
          title="报品报价管理"
        />
        {/* 订退货管理 */}

        {/* 订货通知单 */}
        <Route
          exact
          path="/order/orderNotice"
          cacheKey="/order/orderNotice"
          component={orderNotice}
          title="订货通知单"
        />
        {/* 预采通知单 */}
        <Route
          exact
          path="/order/prePurchase"
          cacheKey="/order/prePurchase"
          component={PrePurchase}
          title="预采通知单"
        />
        {/* 预采需求看板 */}
        <Route
          exact
          path="/order/preProcurement"
          cacheKey="/order/preProcurement"
          component={PreProcurement}
          title="预采通知单"
        />

        {/* 订货通知单详情 */}
        <Route
          exact
          path="/order/orderNoticeDes/:id"
          cacheKey="/order/orderNoticeDes"
          component={OrderNoticeDes}
          title="订货通知单详情"
        />

        {/* 验收单 */}
        <Route
          exact
          path="/order/orderAccept"
          cacheKey="/order/orderAccept"
          component={orderAccept}
          title="验收单"
        />
        {/* 验收单详情 */}
        <Route
          exact
          path="/order/orderAcceptDes/:id"
          cacheKey="/order/orderAcceptDes"
          component={orderAcceptDes}
          title="验收单详情"
        />

        {/* 退货通知单 */}
        <Route
          exact
          path="/order/returnNotice"
          cacheKey="/order/returnNotice"
          component={returnNotice}
          title="退货通知单"
        />
        {/* 委外需求明细报表 */}
        <Route
          exact
          path="/order/outsourcingDetailsReport"
          cacheKey="/order/outsourcingDetailsReport"
          component={OutsourcingDetailsReport}
          title="委外需求明细报表"
        />
        {/* 退货通知单详情 */}
        <Route
          exact
          path="/order/returnNoticeDes/:id"
          cacheKey="/order/returnNoticeDes"
          component={returnNoticeDes}
          title="退货通知单详情"
        />
        {/*预约送货*/}
        <Route
          exact
          path="/order/reserveDeliver"
          cacheKey="/order/reserveDeliver"
          component={reserveDeliver}
          title="预约送货"
        />
        {/*预约送货*/}
        <Route
          exact
          path="/order/reserveDeliver/detail/:id"
          cacheKey="/order/reserveDeliver/detail"
          component={reservationDetail}
          title="预约送货详情"
        />
        {/* 退货单 */}
        <Route
          exact
          path="/order/returnFrom"
          cacheKey="/order/returnFrom"
          component={returnFrom}
          title="退货单"
        />
        {/* 退货单详情 */}
        <Route
          exact
          path="/order/returnFromDes/:id"
          cacheKey="/order/returnFromDes"
          component={returnFromDes}
          title="退货单详情"
        />
        {/* 销售数据查询 */}
        <Route
          exact
          path="/order/salesDataQuery"
          cacheKey="/order/salesDataQuery"
          component={salesDataQuery}
          title="销售数据查询"
        />

        <Route
          exact
          path="/order/returnDebitNote"
          cacheKey="/order/returnDebitNote"
          component={ReturnDebitNote}
          title="退货冲销单"
        />

        {/* 退货冲销单详情 */}
        <Route
          exact
          path="/order/returnDebitNoteDetail/:id"
          cacheKey="/order/returnDebitNoteDetail"
          component={ReturnDebitNoteDetail}
          title="退货冲销单详情"
        />
        {/* 系统设置 */}

        {/* 修改登录密码 */}
        <Route
          exact
          path="/setting/editpwd"
          cacheKey="/setting/editpwd"
          component={editPwd}
          title="修改密码"
        />
        {/* 主账号手机修改 */}
        <Route
          exact
          path="/setting/accountPhoneEdit"
          cacheKey="/setting/accountPhoneEdit"
          component={accountPhoneEdit}
          title="主账号手机修改"
        />
        {/* 设置默认供应商 */}
        <Route
          exact
          path="/setting/defaultSelect"
          cacheKey="/setting/defaultSelect"
          component={defaultSelect}
          title="设置默认供应商"
        />

        {/* 供应商与微信管理 */}
        <Route
          exact
          path="/setting/supplierAndWeiChat"
          cacheKey="/setting/supplierAndWeiChat"
          component={supplierAndWeiChat}
          title="供应商与微信管理"
        />

        <Route
          exact
          path="/settlement/yhLifeFreightStatement"
          cacheKey="/settlement/yhLifeFreightStatement"
          component={yhlist}
          title="永辉生活运费对账单"
        />
        {/* 结算管理 */}
        {/* 供应商对账管理 reconciliationManagement */}
        <CacheRoute
          exact
          path="/settlement/reconciliationManagement"
          cacheKey="/settlement/reconciliationManagement"
          component={reconciliationManagement}
          title="对账管理"
        />
        <Route
          exact
          path="/settlement/reconciliationBillCostDetail"
          cacheKey="/settlement/reconciliationBillCostDetail"
          component={reconciliationBillCostDetail}
          title="供应商对账费用单明细详情"
        />
        <Route
          exact
          path="/settlement/claimDetail"
          cacheKey="/settlement/claimDetail"
          component={reconciliationClaimDetail}
          title="供应商对账认领明细"
        />
        <Route
          exact
          path="/settlement/reconciliationBillDetail"
          cacheKey="/settlement/reconciliationBillDetail"
          component={reconciliationBillDetail}
          title="供应商对账单据详情"
        />

        <Route
          exact
          path="/settlement/entryAndCore"
          cacheKey="/settlement/entryAndCore"
          component={entryAndCore}
          title="发票录入和票核"
        />
        <Route
          exact
          path="/settlement/entryAndCore/new/:id"
          cacheKey="/settlement/entryAndCoreDeta"
          component={entryAndCoreDetaNew}
          title="发票录入和票核"
        />
        <Route
          exact
          path="/settlement/entryAndCore/:id"
          cacheKey="/settlement/entryAndCoreDeta"
          component={entryAndCoreDeta}
          title="发票录入和票核"
        />
        <Route
          exact
          path="/settlement/reconciliationBillList"
          cacheKey="/settlement/reconciliationBillList"
          component={reconciliationBillList}
          title="供应商对账单据详情列表"
        />
        <Route
          exact
          path="/settlement/PurchaseOrderMonitoring"
          cacheKey="/settlement/PurchaseOrderMonitoring"
          component={PurchaseOrderMonitoring}
          title="采购单监控"
        />
        <Route
          exact
          path="/settlement/SupplierFeeComplaint"
          cacheKey="/settlement/SupplierFeeComplaint"
          component={SupplierFeeComplaint}
          title="供应商费用申诉"
        />
        {/*  */}
        {/*报表查询*/}
        <Route
          exact
          path="/reportQuery/signatureStatement"
          cacheKey="/reportQuery/signatureStatement"
          component={signatureStatement}
          title="对账单签章状态查询"
        />
        <Route
          exact
          path="/reportQuery/unpaidAmount"
          cacheKey="/reportQuery/unpaidAmount"
          component={unpaidAmount}
          title="供应商款项信息查询"
        />
        <Route
          exact
          path="/reportQuery/documentFreezing"
          cacheKey="/reportQuery/documentFreezing"
          component={documentFreezing}
          title="对账单据明细查询"
        />
        <Route
          exact
          path="/reportQuery/vendorPayment"
          cacheKey="/reportQuery/vendorPayment"
          component={vendorPayment}
          title="付款单查询"
        />
        <Route
          exact
          path="/reportQuery/reconciliationInformation"
          cacheKey="/reportQuery/reconciliationInformation"
          component={reconciliationInformation}
          title="对账信息查询"
        />
        <Route
          exact
          path="/reportQuery/invoiceManagement"
          cacheKey="/reportQuery/invoiceManagement"
          component={invoiceManagement}
          title="票核情况查询"
        />
        <Route
          exact
          path="/reportQuery/expenseQuery"
          cacheKey="/reportQuery/expenseQuery"
          component={expenseQuery}
          title="供应商费用单查询"
        />
        {/*商品管理*/}
        <Route
          exact
          path="/productManagement/productStockPrice"
          cacheKey="/productManagement/productStockPrice"
          component={productStockPrice}
          title="商品库存报价管理"
        />
        <Route
          exact
          path="/productManagement/productStockPriceImport"
          cacheKey="/productManagement/productStockPriceImport"
          component={productStockPriceImport}
          title="商品库存报价管理导入"
        />
        {/*电子签章*/}
        <Route
          exact
          path="/ESignature/businessApplications"
          cacheKey="/ESignature/businessApplications"
          component={businessApplications}
          title="云签业务申请"
        />
        <Route
          exact
          path="/ESignature/businessQueries"
          cacheKey="/ESignature/businessQueries"
          component={businessQueries}
          title="云签业务查询"
        />
        <Route
          exact
          path="/ESignature/changeQueries"
          cacheKey="/ESignature/changeQueries"
          component={changeQueries}
          title="手机变更查询"
        />
        <Route
          exact
          path="/ESignature/changeQueries/details"
          cacheKey="/ESignature/changeQueries/details"
          component={changeQueriesDeta}
          title="手机变更查询详情"
        />
        <Route
          exact
          path="/ESignature/applyApproval"
          cacheKey="/ESignature/applyApproval"
          component={applyApproval}
          title="云签签章申请审批"
        />
        <Route
          exact
          path="/ESignature/applyApproval/details/:id"
          cacheKey="/ESignature/applyApproval/details"
          component={applyApprovalDetails}
          title="云签签章申请审批"
        />
        <Route
          exact
          path="/ESignature/phoneChangeApproval"
          cacheKey="/ESignature/phoneChangeApproval"
          component={phoneChangeApproval}
          title="云签手机号变更审批"
        />
        <CacheRoute
          exact
          path="/ESignature/editPhone"
          cacheKey="/ESignature/editPhone"
          component={editPhone}
          title="云签手机号新增/变更"
        />
        {/*bbc供应商协同管理平台*/}
        <Route
          exact
          path="/bbc/bbcOrderDetail/:id"
          cacheKey="/bbc/bbcOrderDetail"
          component={bbcOrderDetail}
          title="订单详情"
        />

        <Route
          exact
          path="/bbc/bbcOrderManagement"
          cacheKey="/bbc/bbcOrderManagement"
          component={bbcOrderManagement}
          title="供应商订单管理"
        />
        <Route
          exact
          path="/bbc/GoodsManagement"
          cacheKey="/bbc/GoodsManagement"
          component={bbcGoodsManagement}
          title="供应商商品管理"
        />
        <Route
          exact
          path="/bbc/bbcGoodsView/:id"
          cacheKey="/bbc/bbcGoodsView"
          component={bbcGoodsView}
          title="供应商商品详情"
        />
        <Route
          exact
          path="/bbc/NewbbcGoodsView/:id"
          cacheKey="/bbc/NewbbcGoodsView"
          component={NewbbcGoodsView}
          title="供应商商品详情新"
        />
        <Route
          exact
          path="/bbc/bbcGoodsChange/:id"
          cacheKey="/bbc/bbcGoodsChange"
          component={bbcGoodsChange}
          title="供应商商品变更"
        />
        <Route
          exact
          path="/bbc/bbcGoodsChangeNew/:id"
          cacheKey="/bbc/bbcGoodsChangeNew"
          component={BbcGoodsChangeNew}
          title="供应商商品变更新"
        />
        <Route
          exact
          path="/bbc/bbcPerformanceManagement/expressSearch"
          cacheKey="/bbc/bbcPerformanceManagement/expressSearch"
          component={expressSearch}
          title="快递单查询"
        />
        <Route
          exact
          path="/bbc/bbcPerformanceManagement/holiday"
          cacheKey="/bbc/bbcPerformanceManagement/holiday"
          component={holiday}
          title="不发货时间段"
        />
        <Route
          exact
          path="/bbc/bbcPerformanceManagement/Scope"
          cacheKey="/bbc/bbcPerformanceManagement/Scope"
          component={Scope}
          title="配送范围限制"
        />
        <Route
          exact
          path="/ESignature/businessApplications"
          cacheKey="/ESignature/businessApplications"
          component={businessApplications}
          title="云签业务申请"
        />
        <Route
          exact
          path="/ESignature/businessQueries"
          cacheKey="/ESignature/businessQueries"
          component={businessQueries}
          title="云签业务查询"
        />
        <Route
          exact
          path="/ESignature/changeQueries"
          cacheKey="/ESignature/changeQueries"
          component={changeQueries}
          title="手机变更查询"
        />
        <Route
          exact
          path="/ESignature/changeQueries/details"
          cacheKey="/ESignature/changeQueries/details"
          component={changeQueriesDeta}
          title="手机变更查询详情"
        />
        <Route
          exact
          path="/ESignature/applyApproval"
          cacheKey="/ESignature/applyApproval"
          component={applyApproval}
          title="云签签章申请审批"
        />
        <Route
          exact
          path="/ESignature/applyApproval/details/:id"
          cacheKey="/ESignature/applyApproval/details"
          component={applyApprovalDetails}
          title="云签签章申请审批"
        />
        <Route
          exact
          path="/ESignature/phoneChangeApproval"
          cacheKey="/ESignature/phoneChangeApproval"
          component={phoneChangeApproval}
          title="云签手机号变更审批"
        />
        <CacheRoute
          exact
          path="/ESignature/editPhone"
          cacheKey="/ESignature/editPhone"
          component={editPhone}
          title="云签手机号新增/变更"
        />

        {/*bbc履约管理*/}
        {/* 报价单 */}
        <Route
          exact
          path="/priceManagement/priceList"
          cacheKey="/priceManagement/priceList"
          component={priceList}
          title="报价单"
        />
        <Route
          exact
          path="/cardManagement/supplyType"
          cacheKey="/cardManagement/supplyType"
          component={supplyType}
          title="商品型检证件"
        />
        <Route
          exact
          path="/cardManagement/supplyTypeNew"
          cacheKey="/cardManagement/supplyTypeNew"
          component={credentialsTypeReportNew}
          title="商品型检证件"
        />
        <Route
          exact
          path="/cardManagement/batchInspectionCertificate"
          cacheKey="/cardManagement/batchInspectionCertificate"
          component={BatchInspectionCertificate}
          title="商品批检证件"
        />
        <Route
          exact
          path="/cardManagement/supplier"
          cacheKey="/cardManagement/supplier"
          component={credentialsSupplierReport}
          title="供应商证件"
        />
        <CacheRoute
          exact
          path="/invoiceManagement/ApplyBilling"
          cacheKey="/invoiceManagement/ApplyBilling"
          component={ApplyBilling}
          title="开票申请"
        />
        <CacheRoute
          exact
          path="/invoiceManagement/InvoiceRecord"
          cacheKey="/invoiceManagement/InvoiceRecord"
          component={InvoiceRecord}
          title="开票申请记录"
        />
        <CacheRoute
          exact
          path="/invoiceManagement/BillingInquiry"
          cacheKey="/invoiceManagement/BillingInquiry"
          component={BillingInquiry}
          title="开票查询"
        />
        {/*----------- 404  -------------------*/}
        <Route
          exact
          path="/order/sortingDataQuery"
          cacheKey="/order/sortingDataQuery"
          component={SortingDataQuery}
          title="委外实时分拣数量查询"
        />

        <Route path="/404" component={notFound404} />

        {pageRouterList.map(item => {
          if (item.isRedirect) {
            return <Redirect from="*" to={item.to} key="redirect" />;
          }
          if (item.isNoCache) {
            return <Route {...item} key={item.path} />;
          }
          return <CacheRoute {...item} key={item.path} />;
        })}
      </CacheSwitch>
    </Router>
  </CoreLayout>
);

const detailRouterList = routerConfigData.filter(item => item.isDetail);

export default () => (
  <Router history={history}>
    <Switch>
      <Route exact path="/" component={login} />
      {/* 模板自动添加 */}
      {detailRouterList.map(item => (
        <Route {...item} key={item.path} />
      ))}
      {/* 注册 */}
      <Route
        exact
        path="/registered"
        cacheKey="/registered"
        component={userRegistered}
        title="注册"
      />
      {/* 供应商建档注册 */}
      <Route
        exact
        path="/supplier/registered"
        cacheKey="/supplier/registered"
        component={supplierRegistered}
        title="注册"
      />
      <Route
        exact
        path="/findPhoneNum"
        cacheKey="/findPhoneNum"
        component={FindPhoneNum}
        title="子账号管理"
      />

      {/* 订货通知单门店明细 */}
      <Route
        exact
        path="/order/StoreDetails/:id"
        cacheKey="/order/StoreDetails"
        component={StoreDetails}
        title="门店明细"
      />
      {/* 订货通知单打印单据 */}
      <Route
        exact
        path="/order/printDocument/:id"
        cacheKey="/order/printDocument"
        component={printDocument}
        title="订货通知单打印单据"
      />
      {/* 验收单打印 orderAcceptPrint */}
      <Route
        exact
        path="/order/orderAcceptPrint/:id"
        cacheKey="/order/orderAcceptPrint"
        component={orderAcceptPrint}
        title="验收单打印单据"
      />
      {/* 退货通知单打印 */}
      <Route
        exact
        path="/order/returnNoticePrint/:id"
        cacheKey="/order/returnNoticePrint/:id"
        component={returnNoticePrint}
        title="退货通知单打印"
      />
      {/* 退货单打印 */}
      <Route
        exact
        path="/order/returnFromPrint/:id"
        cacheKey="/order/returnFromPrint"
        component={returnFromPrint}
        title="退货单打印"
      />
      <Route
        exact
        path="/order/prePurchase/detail/:id"
        component={PrePurchaseDetail}
        title="预采通知单详情"
      />
      {/*  对账打印页面*/}
      <Route
        exact
        path="/order/reconciliation/reconciliationAndPayment"
        component={reconciliationAndPayment}
      />
      <Route component={mainLayout} />
    </Switch>
  </Router>
);
